import { useSnapshot } from 'valtio';

import { useTheme } from '@mui/material/styles';

import CreditCardIcon from '@mui/icons-material/CreditCard';

import { BaseIndicator } from '@/components/common';

import {
  getEnergyUsageExpandedV2QueryWhereClauseFromFilters,
  store,
} from '@/components/pages/EmissionsDashboard';

import { useGetEnergyUsageExpandedV2EtsSumAggregateQuery } from '@/graphql/GetEnergyUsageExpandedV2ETSSumAggregate.generated';

function ETSIndicator() {
  const snap = useSnapshot(store);
  const theme = useTheme();

  const where = getEnergyUsageExpandedV2QueryWhereClauseFromFilters(
    snap as typeof store,
  );

  const [{ data, fetching, error: _error }, _reexecuteQuery] =
    useGetEnergyUsageExpandedV2EtsSumAggregateQuery({
      variables: {
        where,
      },
    });

  const ets =
    data?.container_insights_energy_usage_expanded_v2_aggregate.aggregate?.sum
      ?.ets_euro || null;

  return (
    <BaseIndicator
      value={fetching ? null : ets}
      format="currency"
      sublabel="ETS"
      icon={<CreditCardIcon color="primary" />}
      color={theme.palette.primary.main}
      loading={fetching}
    />
  );
}

export { ETSIndicator };
